import ConsentScreenTracker from './ConsentScreen';
import FriendsAndFavoritesMenuTracker from './FriendsAndFavorites';
import PeekWindowTracker from './PeekWindow';
import BuyTokenOverlayTracker from './BuyTokenOverlay';


export const friendsAndFavoritesMenuTracker = new FriendsAndFavoritesMenuTracker();
export const peekWindowTracker = new PeekWindowTracker();
export const consentScreenTracker = new ConsentScreenTracker();
export const buyTokenOverlayTracker = new BuyTokenOverlayTracker();
